const device = {
    namespaced: true,
    state: {
        deviceList:[],
        selectedDevice: null,
        deviceTypeList:[],
        organizationDeviceParameters: {
          list: []
        }
    },
    mutations: {
        updateDeviceList(state , newList ) {
            state.deviceList = newList
        },
        updateSelectedDevice(state , newDevice ) {
            state.selectedDevice = newDevice
        },
        updateDeviceTypeList( state , newList ) {
            state.deviceTypeList = newList
        },
        setOrganizationDeviceParameters(state, newList) {
          state.organizationDeviceParameters.list = newList;
        }
    },
    actions: {
        getDeviceList( context ) {
            this._vm.$traveller_http.get('/traveller/restui/device/general/getDevices')
            .then( response => {
                context.commit('updateDeviceList' , response.data )
            })
        } , 
        updateDevice(context , newDevice ) {
            delete newDevice.infopoint;
            return new Promise((resolve , reject) => {
                this._vm.$traveller_http.post('/traveller/restui/device/general/saveDevice' , 
                    newDevice )
                .then ( response => {
                    if( response.status == 200 )
                        context.dispatch('getDeviceList');
                    resolve(response);
                }).catch( error => {
                    reject(error);
                })
            } )

        },
        getDeviceTypeList(context) {
            this._vm.$traveller_http.get('/traveller/restui/device/general/getDeviceTypes')
            .then( response => {
                context.commit('updateDeviceTypeList', response.data)
            })
        },
        deleteDevice(context, deviceId) {
            return new Promise((resolve , reject ) => {
                let config = {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
                this._vm.$traveller_http.post('/traveller/restui/device/general/deleteDevice',
                    deviceId , config ).then(
                        response => {
                            if( response.status == 200 )
                                context.dispatch('getDeviceList');
                            resolve(response)
                            context.commit('updateSelectedDevice' , null )
                        } ).catch( (error) => {
                            reject(error)
                        }) 
            })
        },
        getOrganizationDeviceParameters(context, organization) {
            return new Promise((resolve , reject) => {
                this._vm.$traveller_http.get('/traveller/restui/device/general/getOrganizationDeviceParameters', { params: { "organization": organization }})
                   .then( response => {
                        //console.log(response)
                        if( response.data.code && response.response.data.code != 0 ) {
                            reject()                
                            return
                        }
                        //console.log("Commit data")
                        //console.log(response.data)
                       context.commit('setOrganizationDeviceParameters', response.data );
                       resolve(response.data)
                }).catch( error => {
                    reject(error)
                } );
            })   
        }
    },
    getters: {
        getDeviceById: (state) => (id) => {
            return state.deviceList.find( dev => dev.deviceId === id);
        }
    }
}

export default device;
